import { render } from "./SkillLogoComponent.vue?vue&type=template&id=5202c58d&ts=true"
import script from "./SkillLogoComponent.vue?vue&type=script&lang=ts"
export * from "./SkillLogoComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__